// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-image-container {
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin: 0 auto 16px auto;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border: 2px solid var(--theme-consistent);
}

.profile-image {
  position: relative;
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
  overflow: hidden; /* This will make sure the image stays within the circular border */
}

.profile-image::before {
  content: "";
  display: block;
  padding-bottom: 100%;
  background-image: inherit; /* This will apply the image from the parent element */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
}

.profile-image-label {
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 36px;
  height: 36px;
  background-color: var(--theme-consistent);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.camera-icon {
  color: white;
  font-size: 16px;
}

.plus-icon {
  position: absolute;
  color: var(--secondary-theme);
  top: 0px;
  right: 0px;
}

.file-upload-input {
  display: none;
}

.upload-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #ffffff;
  border-top: 3px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.image-upload-message {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 8px;
  text-align: center;
  width: max-content;
  max-width: 200px;
  background-color: var(--theme-consistent);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
}

@media (max-width: 768px) {
  .profile-image-container {
    width: 120px;
    height: 120px;
  }

  .profile-image-label {
    width: 30px;
    height: 30px;
  }

  .plus-icon {
    top: -8px;
    right: -3px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/ImageUpload.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB,EAAE,mEAAmE;AACvF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,yBAAyB,EAAE,sDAAsD;EACjF,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF","sourcesContent":[".profile-image-container {\n  position: relative;\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  margin: 0 auto 16px auto;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);\n  border: 2px solid var(--theme-consistent);\n}\n\n.profile-image {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  border-radius: 50%;\n  overflow: hidden; /* This will make sure the image stays within the circular border */\n}\n\n.profile-image::before {\n  content: \"\";\n  display: block;\n  padding-bottom: 100%;\n  background-image: inherit; /* This will apply the image from the parent element */\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  border-radius: 50%;\n}\n\n.profile-image-label {\n  position: absolute;\n  bottom: -4px;\n  right: -4px;\n  width: 36px;\n  height: 36px;\n  background-color: var(--theme-consistent);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.camera-icon {\n  color: white;\n  font-size: 16px;\n}\n\n.plus-icon {\n  position: absolute;\n  color: var(--secondary-theme);\n  top: 0px;\n  right: 0px;\n}\n\n.file-upload-input {\n  display: none;\n}\n\n.upload-loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loading-spinner {\n  width: 30px;\n  height: 30px;\n  border: 3px solid #ffffff;\n  border-top: 3px solid transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.image-upload-message {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-top: 8px;\n  text-align: center;\n  width: max-content;\n  max-width: 200px;\n  background-color: var(--theme-consistent);\n  color: white;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n@media (max-width: 768px) {\n  .profile-image-container {\n    width: 120px;\n    height: 120px;\n  }\n\n  .profile-image-label {\n    width: 30px;\n    height: 30px;\n  }\n\n  .plus-icon {\n    top: -8px;\n    right: -3px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
